import { PriceCategory } from "src/types/configuration";

type PriceItem = {
  name: string;
  label: string;
  unit: string;
  price: number;
  category: PriceCategory;
};

const prices: PriceItem[] = [
  {
    name: "betonproer",
    label: "Betonpoer 15 x 15 x 60 cm",
    unit: "stuk",
    price: 59.0,
    category: "A",
  },
  {
    name: "betontegel",
    label: "Betontegel 18x18x10",
    unit: "stuk",
    price: 29.0,
    category: "A",
  },
  {
    name: "staanders",
    label: "Staander 15 x 15 x 250 cm",
    unit: "stuk",
    price: 87.21,
    category: "A",
  },
  {
    name: "ringbalk",
    label: "Gording 5 x 15 x 400 cm",
    unit: "stuk",
    price: 29.4,
    category: "A",
  },
  {
    name: "gordingbalken",
    label: "Liggers 5 x 15",
    unit: "m",
    price: 7.35,
    category: "A",
  },
  {
    name: "boeideel",
    label: "Boeideel 2,5 x 20",
    unit: "m",
    price: 7.25,
    category: "A",
  },
  {
    name: "daktrim_blank",
    label: "Daktrim blank",
    unit: "m",
    price: 9.5,
    category: "A",
  },
  {
    name: "daktrim_zwart",
    label: "Daktrim zwart",
    unit: "m",
    price: 19.75,
    category: "A",
  },
  {
    name: "wood_frame",
    label: "Regels douglas voor wanden, incl. schroeven",
    unit: "m",
    price: 3.78,
    category: "A",
  },
  {
    name: "wall_potdeksel_black",
    label: "Rabat douglas zwart 300 x 1,2 x 19,5 cm",
    unit: "m",
    price: 4.83,
    category: "A",
  },
  {
    name: "wall_vuren_black",
    label: "Rabat vuren zwart 300 x 1,2 x 19,5 cm",
    unit: "m",
    price: 4.83,
    category: "A",
  },
  {
    name: "wall_potdeksel",
    label: "Rabat douglas naturel 300 x 1,2 x 19,5 cm",
    unit: "m",
    price: 4.42,
    category: "A",
  },
  {
    name: "wall_blockhut",
    label: "Blokhutprofiel 300 x 2,8 x 19,5 cm",
    unit: "m",
    price: 8.83,
    category: "A",
  },
  {
    name: "wall_blockhut_black",
    label: "Blokhutprofiel zwart 300 x 2,8 x 19,5 cm",
    unit: "m",
    price: 8.83,
    category: "A",
  },
  {
    name: "raam",
    label: "Vast raam douglas naturel kozijnmaat 642x1168 sponningmaat 592x1118mm",
    unit: "stuk",
    price: 405.0,
    category: "A",
  },
  {
    name: "vleugelraam",
    label:
      "Uitzetraam enkel 768x1168 + kozijn 902x1302mm",
    unit: "stuk",
    price: 575.0,
    category: "A",
    // pricing-table.tsv currently lacks an updated price; legacy value retained.
  },
  {
    name: "dichte_73cm_right",
    label: "Enkele dichte deur rechtsdraaiend 78 x 198 cm",
    unit: "stuk",
    price: 825.0,
    category: "A",
  },
  {
    name: "dichte_73cm_left",
    label: "Enkele dichte deur linksdraaiend 78 x 198 cm",
    unit: "stuk",
    price: 825.0,
    category: "A",
  },
  {
    name: "dichte_100cm_right",
    label: "Enkele dichte deur rechtsdraaiend 78 x 195 cm",
    unit: "stuk",
    price: 739.0,
    category: "A",
    // pricing-table.tsv marks this as next release; value pending confirmation.
  },
  {
    name: "dichte_100cm_left",
    label: "Enkele dichte deur linksdraaiend 78 x 195 cm",
    unit: "stuk",
    price: 739.0,
    category: "A",
    // pricing-table.tsv marks this as next release; value pending confirmation.
  },
  {
    name: "stapeldorpeldeur_right",
    label:
      "Douglas deur enkel naturel rechtsdraaiend met raam 93x195+kozijn106x202cm",
    unit: "stuk",
    price: 995.0,
    category: "A",
    // No updated price present in pricing-table.tsv (legacy value retained).
  },
  {
    name: "stapeldorpeldeur_left",
    label:
      "Douglas deur enkel naturel linksdraaiend met raam 93x195+kozijn106x202cm",
    unit: "stuk",
    price: 995.0,
    category: "A",
    // No updated price present in pricing-table.tsv (legacy value retained).
  },
  {
    name: "dubbele_dichte",
    label: "Douglas dubbele deur naturel 186x195 +kozijn 200x202 cm",
    unit: "stuk",
    price: 1395.0,
    category: "A",
  },
  {
    name: "dubble_stapeldorpeldeur",
    label: "Dougals dubbele deur naturel 186x195 + kozijn 200x202 cm bw 689mm",
    unit: "stuk",
    price: 1595.0,
    category: "A",
  },
  {
    name: "dakbeschot",
    label:
      "Douglas dakbeschot 1,8 x 14,5 x 400 cm 1 zijde geschaafd, 1 zijde fijnbezaagd",
    unit: "m²",
    price: 33.89,
    category: "A",
  },
  {
    name: "epdmGlue",
    label: "EPDM + lijm",
    unit: "m²",
    price: 23.75,
    category: "A",
  },
  {
    name: "dakpanprofielen-zwart",
    label: "Dakpanprofielen zwart",
    unit: "m²",
    price: 48.0,
    category: "A",
  },
  {
    name: "dakpanprofielen-terracotta",
    label: "Dakpanprofielen terracotta",
    unit: "m²",
    price: 48.0,
    category: "A",
  },
  {
    name: "shingles-zwart",
    label: "Shingles zwart",
    unit: "m²",
    price: 9.95,
    category: "A",
  },
  {
    name: "shingles-groen",
    label: "Shingles groen",
    unit: "m²",
    price: 9.95,
    category: "A",
  },
  {
    name: "shingles-rood",
    label: "Shingles rood",
    unit: "m²",
    price: 9.95,
    category: "A",
  },
  {
    name: "daktrim",
    label: "Daktrim betimmering (4 x 6 cm)",
    unit: "m",
    price: 3.78,
    category: "A",
  },
  {
    name: "glaselement",
    label: "Glaselement",
    unit: "stuk",
    price: 405.0,
    category: "B",
  },
  {
    name: "geleider",
    label: "Geleider",
    unit: "stuk",
    price: 0.0,
    category: "B",
  },
  {
    name: "dakgoot_zinkkleur",
    label: "Dakgoot pvc",
    unit: "m",
    price: 27.50,
    category: "A",
  },
  {
    name: "regenwaterafvoer_zinkkleur",
    label: "HWA afvoer incl. pijp",
    unit: "stuk",
    price: 35.0,
    category: "A",
  },
  {
    name: "dakgoot_zink_zwart",
    label: "Dakgoot pvc",
    unit: "m",
    price: 27.5,
    category: "A",
  },
  {
    name: "regenwaterafvoer_zink_zwart",
    label: "Hemelwaterafvoer pvc",
    unit: "m",
    price: 35.0,
    category: "A",
  },
  {
    name: "liter_beits_zwart",
    label: "Remmers Zwart 9005",
    unit: "stuk",
    price: 44.0,
    category: "NVT",
  },
  {
    name: "liter_beits_wit",
    label: "Remmers Wit 9010",
    unit: "stuk",
    price: 44.0,
    category: "NVT",
  },
  {
    name: "liter_beits_gray",
    label: "Remmers Grafietgrijs",
    unit: "stuk",
    price: 44.0,
    category: "NVT",
  },
  {
    name: "liter_beits_douglas",
    label: "Remmers Douglas",
    unit: "stuk",
    price: 44.0,
    category: "NVT",
  },
  {
    name: "doorBrushes",
    label: "Tochtborstels",
    unit: "stuk",
    price: 25.0,
    category: "B",
  },
  {
    name: "stainlessSteelHandle",
    label: "Handgreep RVS",
    unit: "stuk",
    price: 0,
    category: "B",
  },
  {
    name: "lockProfile",
    label: "Vergrendelprofiel",
    unit: "stuk",
    price: 60.0,
    category: "B",
  },
  {
    name: "schuifrichting",
    label: "Schuifrichting",
    unit: "stuk",
    price: 0,
    category: "B",
  },
  {
    name: "meenemers",
    label: "Meenemers",
    unit: "stuk",
    price: 0,
    category: "B",
  },
  {
    name: "glasbok_zwart",
    label: "Glasbok zwart",
    unit: "stuk",
    price: 30.0,
    category: "B",
  },
  {
    name: "glasbok_antraciet",
    label: "Glasbok antraciet",
    unit: "stuk",
    price: 30.0,
    category: "B",
  },
  {
    name: "glasbok_wit",
    label: "Glasbok wit",
    unit: "stuk",
    price: 30.0,
    category: "B",
  },
  {
    name: "bevestigingsmaterialen",
    label: "Bevestigingsmaterialen",
    unit: "stuk",
    price: 45.0,
    category: "NVT",
  },
  {
    name: "hemelwaterafvoer_pvc",
    label: "HWA afvoer incl. pijp.",
    unit: "stuk",
    price: 35.0,
    category: "A",
  },
  {
    name: "betonband_antraciet",
    label: "Betonband antraciet 6x20x100cm",
    unit: "stuk",
    price: 10.5,
    category: "A",
  },
];

export default prices;
